<div class="review-container">
  <h3 class="title">{{dataPayload.data.mat_nombre}}</h3>

  <div class="comparison-images">
    <img *ngIf="currentPreview" [src]="currentPreview" alt="Versión Actual" (click)="openImage(currentPreview, 'Versión Actual',false)" style="cursor: pointer;" />
    <img [src]="dataPayload.apiRes.imgRecorte" alt="Imagen Capturada" (click)="openImage(dataPayload.apiRes.imgRecorte, 'Imagen Capturada',dataPayload.data.isMirrored)" style="cursor: pointer;" [ngClass]="{ 'flip-horizontal': dataPayload.data.isMirrored }" />
  </div>

  <div class="extracted-text">
    <!--<ng-container>
      <h4>Texto extraído</h4>
        <p>
            {{dataPayload.apiRes.texto}}
        </p>
    </ng-container>-->
  </div>

  <div class="action-buttons">
    <button class="btn-repeat" (click)="onRepeat()"><i class="pi pi-refresh"></i> Repetir</button>
    <button class="btn-cancel" (click)="onCancel(0)">Cancelar</button>
    <button class="btn-capture" (click)="ruSure()">Guardar</button>
  </div>

  <div class="mt-3 mb-3 d-flex align-items-center justify-content-center">
    <span class="p-input-icon-left">
      <i class="pi pi-search"></i>
      <input
        type="text"
        pInputText
        placeholder="Buscar..."
        [(ngModel)]="search"
        (input)="onSearch(search)"
      />
    </span>
  </div>
 
 
  <ng-container *ngIf="!this.dataPayload.data.version">
     <h4>Top de coincidencias</h4>

     <div class="match-grid">
       <div *ngFor="let item of filteredVersions"
         class="match-item"
         [class.selected]="item === selected"
         (click)="select(item)">
         <img [src]="item.url"/>
          <span class="status captured mt-1" *ngIf="item.capturas > 0">
            Capturada
          </span>
          <span class="status mt-1" *ngIf="item.capturas == 0">&nbsp;</span>
       </div>
     </div>
     <br>
     <div class="accept-btn">
         <button class="view-all-btn" (click)="onVersionList(0)"><i class="pi pi-eye"></i>Ver todas las versiones</button>
     </div>
  </ng-container>


</div>